module.exports = __webpack_public_path__ + "static/media/카.9c75b80f.jpg";